<template>
  <div style="padding-top: 12px;width:1228px;" align="center">
    <div class="mb-10" style="float:left;">
      <img :src="introImage1" usemap="#map" name="appMain" class="mb-10" />
    </div>

    <map name="map">
      <area
        shape="rect"
        coords="335,464,679,527"
        v-bind:href="`/authservice/${$store.state.mallId}/createAuthcode`"
        target="_blank"
      />
    </map>
    <MallManagerInfo ref="MallManagerInfo"></MallManagerInfo>
  </div>
</template>

<script>
import M from "@/libs/mapping.js";
import MallManagerInfo from "@/components/authservice/service/modal/MallManagerInfo.vue";
import CommonMixin from "@/mixins/CommonMixin.js";
export default {
  data: () => ({
    M,
    introImage1: require("../../assets/authservice/images/soundcat_app_new_main.png"),
    ordersPayload: {
      mall_name: null,
      mall_manager: null,
      mall_phone: null,
      mall_email: null,
    },
  }),
  mixins: [CommonMixin],
  methods: {
    moveIntro: function() {
      let route = this.$router.resolve({
        path: `/authservice/${this.$store.state.mallId}/createAuthcode`,
      });
      window.open(route.href, "_blank");
    },
    getPaymentInfo: async function() {
      try {
        let data = await M.api(M.entry("/api/orders/latest"), {});
        if (data) {
          this.ordersPayload.mall_name = data.mall_name;
          this.ordersPayload.mall_manager = data.mall_manager;
          this.ordersPayload.mall_phone = data.mall_phone;
          this.ordersPayload.mall_email = data.mall_email;
        }
      } catch {
        this.ordersPayload.mall_name = "";
        this.ordersPayload.mall_manager = "";
        this.ordersPayload.mall_phone = "";
        this.ordersPayload.mall_email = "";
      }
    },
  },
  created: async function() {
    await this.getPaymentInfo();
    if (!this.ordersPayload.mall_phone) {
      this.$refs.MallManagerInfo.show(this.ordersPayload);
    }
  },
  mounted: function() {},
  components: {
    MallManagerInfo,
  },
};
</script>
